import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-dialogbubble', 'open', 'Pasikalbėkime');
